import { IconWrapper } from '../runtime';
export default IconWrapper('original-link', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M15 7.99969C15 11.8657 11.866 14.9997 8 14.9997C4.13401 14.9997 1 11.8657 1 7.99969C1 4.1337 4.13401 0.999695 8 0.999695C11.866 0.999695 15 4.1337 15 7.99969Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.64231 6.45227L10.4308 5.18944C10.6653 5.11126 10.8884 5.33438 10.8103 5.56891L9.54744 9.3574C9.51758 9.44698 9.44728 9.51727 9.3577 9.54713L5.56922 10.81C5.33469 10.8881 5.11157 10.665 5.18974 10.4305L6.45257 6.642C6.48243 6.55242 6.55273 6.48213 6.64231 6.45227Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});